import { attachChildErrorHandler } from './handle-error.js';
import { attachChildExitHandler } from './handle-exit.js';
import { wireChildOutputPipes } from './pipe-output.js';
import { startMergedLogPoll } from './poll-merged-log.js';
import type { WirePreviewEnvironmentChildDeps } from './deps.js';

export type { WirePreviewEnvironmentChildDeps } from './deps.js';

/**
 * Pipe stdout/stderr into tails + firehose, optional merged-log polling, and exit/error → `preview_environment_status`.
 */
export function wirePreviewEnvironmentChildProcess(d: WirePreviewEnvironmentChildDeps): void {
  wireChildOutputPipes(d);
  startMergedLogPoll(d);
  attachChildExitHandler(d);
  attachChildErrorHandler(d);
}
